import Wallet from '../pages/Wallet.vue';

const walletRoutes = [
  {
    path: '/financial-management/wallet',
    name: '  کیف پول اعتباری',
    component: Wallet,
    meta: {
      roles: ['merchant', 'supplier'],
    },
  },
];
export default walletRoutes;
